const transliterateCyrillicToLatin = (str) => {
    const map = {
        а: 'a', б: 'b', в: 'v', г: 'g', д: 'd', е: 'e', ё: 'e', ж: 'zh', з: 'z',
        и: 'i', й: 'y', к: 'k', л: 'l', м: 'm', н: 'n', о: 'o', п: 'p', р: 'r',
        с: 's', т: 't', у: 'u', ф: 'f', х: 'h', ц: 'ts', ч: 'ch', ш: 'sh', щ: 'shch',
        ъ: '', ы: 'y', ь: '', э: 'e', ю: 'yu', я: 'ya',
    };

    return str
        .toLowerCase()
        .split('')
        .map(char => map[char] ?? char)
        .join('');
};

export const slugify = (str = '') => {
    if (!str) return '';

    const newStr = str
        .normalize('NFKD')
        .replace(/[^\w\s-]/g, '')
        .trim()
        .toLowerCase()
        .replace(/[-\s]+/g, '-');

    if (newStr) return newStr;

    // new str is empty probably it's in cyrilicc
    const latinString = transliterateCyrillicToLatin(str);
    const newLatinString = latinString
        .normalize('NFKD')
        .replace(/[^\w\s-]/g, '')
        .trim()
        .replace(/[-\s]+/g, '-');
    if (newLatinString) return newLatinString;

    return 'locationName';
};